import { firestore } from "../../firebase.config"


const HowDidYouHearAboutUs = [
  {label: "🌐 Google", value: "google",}, 
  {label: "📱 Social Media", value: "social media"}, 
  {label: "📣 Ads", value: "ads"}, 
  {label: "📰 Article", value: "article"}, 
  {label: "👥 Referred by a friend/colleague", value: "referred by a friend/colleague", extraInput: true, extraInputLabel: "Specify Name"}, 
  {label: "⚖️ Recommended by my attorney/law office", value: "recommended by my attorney/law office", extraInput: true, extraInputLabel: "Specify Name"}, 
  {label: "❓ Other", value: "other", extraInput: true}, 
]

const updateHowDidYouHearData = async(id, howDidYouHear, email, name, orderNumber = "", userID = "", quoteNumber = "") => {
  try{
    if(howDidYouHear && howDidYouHear.selectedOption && id){
        await firestore.collection("howDidTheyHear").doc(id).set({
          howDidYouHear: howDidYouHear,
          email: email,
          name: name,
          orderNumber: orderNumber,
          userID: userID,
          quoteNumber: quoteNumber,
          timestamp: new Date().getTime(),
        }).then((ref) => {
          localStorage.setItem("howDidYouHear", JSON.stringify(howDidYouHear))
          // setSubmitButton('Continue to Payment');
          // transitionTo('/order/payment');
        }).catch((error) => {
          console.log("error in updateHowDidYouHearData", error)
        });
    }else{
      console.log("howDidYouHear or id is not valid", howDidYouHear, id);
    }
  }catch(error){
    console.log("error in updateHowDidYouHearData", error)
  }
}


export { updateHowDidYouHearData,HowDidYouHearAboutUs };